export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6274.d9b9782c.jpg";